import { createGlobalStyle } from 'styled-components';

// react-resizable/css/styles.css
const ReactResizableStyles = createGlobalStyle`
  /* stylelint-disable unit-allowed-list */

  .react-resizable {
    position: relative;
  }

  .react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    background-position: bottom right;
    padding: 0 3px 3px 0;
  }

  .react-resizable-handle-sw {
    bottom: 0;
    left: 0;
    cursor: sw-resize;
    transform: rotate(90deg);
  }

  .react-resizable-handle-se {
    bottom: 0;
    right: 0;
    cursor: se-resize;
  }

  .react-resizable-handle-nw {
    top: 0;
    left: 0;
    cursor: nw-resize;
    transform: rotate(180deg);
  }

  .react-resizable-handle-ne {
    top: 0;
    right: 0;
    cursor: ne-resize;
    transform: rotate(270deg);
  }

  .react-resizable-handle-w,
  .react-resizable-handle-e {
    top: 50%;
    margin-top: -10px;
    cursor: ew-resize;
  }

  .react-resizable-handle-w {
    left: 0;
    transform: rotate(135deg);
  }

  .react-resizable-handle-e {
    right: 0;
    transform: rotate(315deg);
  }

  .react-resizable-handle-n,
  .react-resizable-handle-s {
    left: 50%;
    margin-left: -10px;
    cursor: ns-resize;
  }

  .react-resizable-handle-n {
    top: 0;
    transform: rotate(225deg);
  }

  .react-resizable-handle-s {
    bottom: 0;
    transform: rotate(45deg);
  }
`;

export default ReactResizableStyles;
